module.exports = __webpack_public_path__ + "img/2023-11.19d49682.jpg";